import React from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import { BagLogo } from "../components/Logo";
import { ArrowLeft, MapPin, Mail, Globe } from "lucide-react";
import { LEGAL } from "../lib/legal";

function Shell({ title, children, testid }) {
  const navigate = useNavigate();
  const { locale } = useI18n();
  const goBack = () => { if (window.history.length > 1) navigate(-1); else navigate(locale === "en" ? "/en" : "/"); };
  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <div className="max-w-md mx-auto bg-[#F9F9F7] min-h-screen pb-12" data-testid={testid}>
        <header className="bg-brand-red text-white rounded-b-3xl px-5 pt-5 pb-6 relative">
          <button data-testid="info-back" onClick={goBack} className="absolute top-5 left-5 bg-white/15 rounded-full p-2 active:scale-95 transition-transform"><ArrowLeft size={18} /></button>
          <div className="flex flex-col items-center gap-1 mt-1">
            <BagLogo size={44} />
            <h1 className="font-display font-black text-xl mt-1">{title}</h1>
          </div>
        </header>
        <main className="px-5 mt-5 text-slate-700 text-sm leading-relaxed space-y-3">{children}</main>
      </div>
    </div>
  );
}

const Placeholder = () => (
  <p className="text-xs text-brand-orange bg-brand-orange/10 rounded-xl p-3">
    [Placeholder tekst — pre javnog lansiranja potrebna je pravna provera i finalni tekst.]
  </p>
);

export function PrivacyPage() {
  return (
    <Shell title="Politika privatnosti" testid="privacy-page">
      <Placeholder />
      <p>Ponesi obrađuje vaše lične podatke (ime, email, broj telefona) isključivo radi obrade i preuzimanja porudžbina.</p>
      <p>Prijava se vrši putem Google naloga. Ne čuvamo lozinke. Podaci o porudžbinama se čuvaju radi vođenja evidencije restorana.</p>
      <p>Ne delimo vaše podatke sa trećim stranama u marketinške svrhe. Za zahteve u vezi sa vašim podacima kontaktirajte restoran.</p>
    </Shell>
  );
}

export function TermsPage() {
  return (
    <Shell title="Uslovi korišćenja" testid="terms-page">
      <Placeholder />
      <p>Ponesi je servis za online poručivanje hrane sa preuzimanjem u restoranu (bez dostave).</p>
      <p>Porudžbina postaje obavezujuća kada je restoran prihvati. Plaćanje se vrši pri preuzimanju (keš ili kartica u restoranu).</p>
      <p>Restoran zadržava pravo da predloži izmenu vremena preuzimanja ili da odbije porudžbinu. Ceo iznos porudžbine izračunava se na serveru.</p>
    </Shell>
  );
}

export function ContactPage() {
  const { locale } = useI18n();
  const en = locale === "en";
  return (
    <Shell title={en ? "Contact" : "Kontakt"} testid="contact-page">
      <div className="bg-white rounded-2xl p-5 space-y-2 shadow-sm">
        <p className="text-[11px] uppercase tracking-wide text-slate-400">{en ? "Platform operator" : "Operater platforme"}</p>
        <p className="font-display font-black text-lg">{LEGAL.entity}</p>
        <p className="flex items-start gap-2">
          <MapPin size={15} className="text-brand-red mt-0.5 shrink-0" />
          <span>{LEGAL.addressLines.join(", ")}<br />{en ? LEGAL.countryEn : LEGAL.countrySr}</span>
        </p>
        <p className="text-sm text-slate-600">{en ? "Tax ID (PIB)" : "PIB"}: <b className="text-slate-800">{LEGAL.pib}</b></p>
        <p className="text-sm text-slate-600">{en ? "Company registration number (MB)" : "Matični broj"}: <b className="text-slate-800">{LEGAL.mb}</b></p>
        <a href={`mailto:${LEGAL.email}`} data-testid="contact-email" className="flex items-center gap-2 text-brand-red font-semibold pt-1"><Mail size={15} /> {LEGAL.email}</a>
        <a href={`https://${LEGAL.web}`} target="_blank" rel="noreferrer" data-testid="contact-web" className="flex items-center gap-2 text-brand-red font-semibold"><Globe size={15} /> {LEGAL.web}</a>
      </div>
    </Shell>
  );
}
